var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconParentpathway(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Future",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "leap:-landing:-v4",
    transform: "translate(-65.000000, -820.000000)",
    stroke: "#000000"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icon-collection",
    transform: "translate(65.000000, 820.000000)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 11.5
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval-Copy-3",
    cx: 6.5,
    cy: 10.5,
    r: 2
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval-Copy-7",
    cx: 12,
    cy: 6,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval-Copy-4",
    cx: 17.5,
    cy: 11.5,
    r: 3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 11,
    cy: 17,
    r: 3.5
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconParentpathway);
export default __webpack_public_path__ + "static/media/icon-parentpathway.81eae4716cf92b16643a7f18ff3f68d6.svg";
export { ForwardRef as ReactComponent };